import { ReactNode } from "react";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./Title.module.css";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import EllipsesVerticalPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/EllipsesVerticalPath";

type TitleProps = {
  children: ReactNode;
  light?: boolean | undefined;
  onMenuButtonClick?: (() => void) | undefined;
  id?: string;
};
function Title({ children, light = false, onMenuButtonClick, id }: TitleProps) {
  const className = light ? styles["lightText"]! : "";

  return (
    <div className={styles["root"]}>
      <FixaText
        id={id}
        className={className}
        textStyle="Heading.L"
        tagName="h2"
      >
        {children}
      </FixaText>
      {onMenuButtonClick && (
        <FixaButton
          size="small"
          ssrIcon={EllipsesVerticalPath}
          iconOnly
          type="secondary"
          inverseTheme
          onClick={onMenuButtonClick}
        />
      )}
    </div>
  );
}

export default Title;
